import { styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { Offer } from 'src/types';
import { PromotionLabel, EtiquetaDGT } from '.';
import { useGetBrand } from 'src/feature-app/hooks';
import logoDasWelt from 'src/assets/other/DasWeltAuto.svg';

interface StyledImageWrapperProps {
  numberOfOffers: number;
  brand?: string;
  isOcasion?: boolean;
}
const RelativeDiv = styled.div`
  width: max-content;
  margin: 0px 5px;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const StyledImageWrapper = styled.div<StyledImageWrapperProps>`
  width: 100%;
  min-height: 70px;
  margin-top: 30px;
  margin-bottom: ${(props) => (props.brand === 'N' ? '16px' : null)};
  position: relative;
  .car-image {
    margin-bottom: ${(props) => (props.isOcasion ? '10%' : '0')};
    margin-top: ${(props) => (props.isOcasion ? '3%' : '0')};
    width: 100%;
  }
  .logo-ocasion {
    position: absolute;
    width: 30%;
  }
  @media (min-width: 560px) {
    margin-top: 0px;
  }
`;

interface DiagonalCartileProps {
  offer: Offer;
  numberOfOffers: number;
}

const offerHasPromotions = (offer: Offer) => offer.promociones && offer.promociones.length > 0;
const offerHasOcasion = (offer: Offer) => offer.ocasion !== undefined;

export const SideViewImageOffer = (props: DiagonalCartileProps) => {
  const { offer, numberOfOffers } = props;
  const brand = useGetBrand();

  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (brand === 'N') {
      if (offer.mediaAssets?.D6MOFASideview) {
        setImageUrl(offer.mediaAssets?.D6MOFASideview);
      }
    } else {
      if (offer.mediaAssets?.D6MOFASidePC) {
        setImageUrl(offer.mediaAssets?.D6MOFASidePC);
      }
    }
  }, [offer, brand]);

  return (
    <div style={{ position: 'relative' }}>
      {offerHasPromotions(offer) ? (
        <RelativeDiv>
          {offer.promociones.map((promocion, index) => {
            return <PromotionLabel offerPromotion={promocion} index={index} />;
          })}
        </RelativeDiv>
      ) : (
        <div className="test-1 etiqueta-vacia" style={{ height: '30px' }}></div>
      )}
      <StyledImageWrapper
        isOcasion={offerHasOcasion(offer)}
        numberOfOffers={numberOfOffers}
        className="styled-image-offer"
        brand={brand}
      >
        {offerHasOcasion(offer) && <img className="logo-ocasion" src={logoDasWelt} />}
        <EtiquetaDGT combustible={offer.etiquetaDGT} />
        <img src={imageUrl} alt={offer.carlineTitle} className="car-image" />
      </StyledImageWrapper>
    </div>
  );
};
